<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list>
        <!-- <v-list-item>
          <v-btn :disabled="!$auth.policies['update-teaching']" class="elevation-0" icon @click="editState = !editState">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-list-item> -->
        <v-list-item @click="deleteState = true" :disabled="!$auth.policies['delete-teaching']">
          <v-list-item-title>Xóa</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <TeachingEditDialog
      :state="editState"
      :selectedTeaching="selectedTeaching"
      @done="$emit('updateDone', selectedTeaching)"
    />
    <TeachingDeleteDialog :state="deleteState" @delete="onDelete" @closeDialog="deleteState = false" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import TeachingEditDialog from '@/modules/teacher/TeachingEditDialog.vue'
import TeachingDeleteDialog from '@/modules/teacher/TeachingDeleteDialog'

export default {
  components: {
    TeachingEditDialog,
    TeachingDeleteDialog,
  },
  props: {
    selectedTeaching: { type: Object, default: () => {} },
  },
  data() {
    return {
      sending: null,
      editState: false,
      deleteState: false,
    }
  },
  computed: {},
  methods: {
    ...mapActions('teaching', ['removeTeaching', 'updateTeaching']),

    async onDelete() {
      this.$loading.active = true
      try {
        const filterTeachers = this.selectedTeaching.teachers.filter((i) => i.id !== this.$route.params.id)
        const filterAssistants = this.selectedTeaching.assistants.filter((i) => i.id !== this.$route.params.id)
        await this.updateTeaching({ id: this.selectedTeaching.id, teachers: filterTeachers, assistants: filterAssistants })
        this.$alert.success('Xoá thành công!')
        this.deleteState = false
        this.$emit('updateDone', this.selectedTeaching)
      } catch (error) {
        console.error(error)
        this.$alert.deleteError()
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
